import { AfterViewInit, Component, ElementRef, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';

// services
import { ResizeService } from '@app/service/resize.service';

// enums
import { ScreenSize } from '@data/enum';

@Component({
    selector: 'app-size-detector',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './size-detector.component.html',
    styleUrls: ['./size-detector.component.scss'],
})
export class SizeDetectorComponent implements AfterViewInit {
    prefix = 'is-';
    sizes = [
        {
            id: ScreenSize.XS,
            name: 'xs',
            css: `d-block d-sm-none`,
        },
        {
            id: ScreenSize.SM,
            name: 'sm',
            css: `d-none d-sm-block d-md-none`,
        },
        {
            id: ScreenSize.MD,
            name: 'md',
            css: `d-none d-md-block d-lg-none`,
        },
        {
            id: ScreenSize.LG,
            name: 'lg',
            css: `d-none d-lg-block d-xl-none`,
        },
        {
            id: ScreenSize.XL,
            name: 'xl',
            css: `d-none d-xl-block`,
        },
    ];

    @HostListener('window:resize', [])
    onResize() {
        this.detectScreenSize();
    }

    constructor(
        private elementRef: ElementRef,
        private resizeSvc: ResizeService
    ) {}

    ngAfterViewInit() {
        this.detectScreenSize();
    }

    private detectScreenSize() {
        const currentSize = this.sizes.find((x) => {
            const el = this.elementRef.nativeElement.querySelector(`.${this.prefix}${x.id}`);
            const isVisible = window.getComputedStyle(el).display !== 'none';
            return isVisible;
        });

        this.resizeSvc.onResize(currentSize.id);
    }
}
